import { getImageProxy as getRouteProxy } from "../submodule/utils/utils";

export const ApiConfig = {
  BASE_URL: process.env.REACT_APP_ADMIN_API_BASE,
  SSO_BASE_URL: `${process.env.REACT_APP_API_BASE}/sso/v1`,
};

const ApiRoutesList = {
  hello: "hello",
  organizations: "organizations",
  syncOrganizations: "Organizations/Sync",
  notifyPortalMessage: "notify/v1/portalmessage",
  addOrganizationDiscount: "organization/{organizationId}/discounts",
  updateOrganization: "organization/{organizationId}",
  apps: "apps",
  updateApp: "app/{appId}",
  orderLogs: `orderlog`,
  changeLogs: `subscriptionchangelog`,
  quotes: "Quotes",
  quoteCustomers: "Quotes/Customers",
  quoteAffiliates: "Quotes/Affiliates",
  quote: "Quotes/{quoteId}",
  copyQuote: "Quotes/{quoteId}/Copy",
  refreshQuote: "Quotes/{quoteId}/Refresh",
  voidQuote: "Quotes/{quoteId}/Void",
  unvoidQuote: "Quotes/{quoteId}/Unvoid",
  downloadQuoteCsv: "Quotes/{quoteId}/DownloadCsv",
  downloadQuotePdf: "Quotes/{quoteId}/DownloadPdf",
  downloadQuoteCommissionCsv: "Quotes/{quoteId}/CommissionCsv",
  downloadQuoteCommissionPdf: "Quotes/{quoteId}/CommissionPdf",
  sendQuoteEmail: "Quotes/{quoteId}/SendEmail",
  quoteEmailProfile: "Quotes/EmailProfile",
  importQuoteSubscriptions: "Quotes/ImportSubscriptions/{customerGuid}",
  previewQuotePrices: "Quotes/PreviewPrices",
  previewQuoteTotals: "Quotes/PreviewTotals",
  quotePromotions: "Quotes/Promotions",
  quotePromotionsCatalog: "Quotes/Promotions/Catalog",
  quotePromotionsRefresh: "Quotes/Promotions/Refresh",
  quoteCoTermOptions: "Quotes/CoTermOptions",
  products: "Products",
  customerProducts: "Products/Customer/{customerGuid}",
};

const SSOApiRoutesList = {
  signInPortal: "signin/cspadmin",
};

export const API_CACHE_KEYS = {
  ORGANIZATIONS: "ORGANIZATIONS",
  SIGN_IN_PORTAL: "SIGN_IN_PORTAL",
  SIGN_OUT_PORTAL: "SIGN_OUT_PORTAL",
  PROFILE_PORTAL: "PROFILE_PORTAL",
  PROFILE: "PROFILE",
  REFRESH: "REFRESH",
  NOTIFY_PORTAL_MESSAGE: "NOTIFY_PORTAL_MESSAGE",
  ADD_ORGANIZATION_DISCOUNT: "ADD_ORGANIZATION_DISCOUNT",
  APP: "APP_SETTINGS",
  ORDERLOGS: "ORDERLOGS",
  CHANGELOGS: "CHANGELOGS",
  QUOTES: "QUOTES",
  QUOTE_TOTALS: "QUOTE_TOTALS",
  PRODUCTS: "PRODUCTS",
  CUSTOMER_PRODUCTS: "CUSTOMER_PRODUCTS",
};

export const ApiRoutes = getRouteProxy(
  ApiConfig.BASE_URL as string,
  ApiRoutesList
) as typeof ApiRoutesList;
export const SSOApiRoutes = getRouteProxy(
  ApiConfig.SSO_BASE_URL as string,
  SSOApiRoutesList
) as typeof SSOApiRoutesList;
